const generateStableId = (text, type) => {
  const cleanText = text.toLowerCase().trim();
  let hash = 0;
  for (let i = 0; i < cleanText.length; i++) {
    const char = cleanText.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return `${type}_${Math.abs(hash)}`;
};

const selectMediumLengthSentence = (sentences) => {
  if (sentences.length === 0) return null;
  if (sentences.length === 1) return sentences[0];
  
  // 过滤掉太长的句子（超过150个字符）
  const reasonableSentences = sentences.filter(s => s.length <= 150);
  
  // 如果过滤后还有句子，从合理长度的句子中选择
  if (reasonableSentences.length > 0) {
    const sorted = [...reasonableSentences].sort((a, b) => a.length - b.length);
    const middleIndex = Math.floor(sorted.length / 2);
    return sorted[middleIndex];
  }
  
  // 如果所有句子都太长，选择最短的句子
  const sorted = [...sentences].sort((a, b) => a.length - b.length);
  return sorted[0];
};

export const processVocabularyWithExamples = (vocabulary, subtitles) => {
  console.log('=== 开始处理词汇和例句 ===');
  console.log('输入词汇数量:', {
    words: vocabulary.words?.length || 0,
    phrases: vocabulary.phrases?.length || 0,
    expressions: vocabulary.expressions?.length || 0
  });
  console.log('字幕数量:', subtitles.length);

  const processItem = (item, itemType, itemTextKey) => {
    const itemText = item[itemTextKey] || item.word || item.phrase || item.expression;
    if (!itemText) return item;

    const matchingSentences = [];
    const searchTerm = itemText.toLowerCase();
    
    // 检查是否是短语（包含空格）
    const isPhrase = searchTerm.includes(' ');

    for (let i = 0; i < subtitles.length; i++) {
      const subtitle = subtitles[i];
      const englishLower = subtitle.english.toLowerCase();
      let matches = false;
      
      if (isPhrase) {
        // 短语直接使用 includes 匹配
        matches = englishLower.includes(searchTerm);
      } else {
        // 单个单词使用单词边界匹配，避免子字符串匹配
        // 使用正则表达式匹配完整单词
        const wordRegex = new RegExp(`\\b${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
        matches = wordRegex.test(englishLower);
      }
      
      if (matches) {
        matchingSentences.push({
          text: subtitle.english,
          chinese: subtitle.chinese,
          length: subtitle.english.length,
          index: i
        });
      }
    }

    let sentence = item.sentence || '';
    let sentenceChinese = item.sentenceChinese || '';
    let subtitleIndex = item.subtitleIndex;

    if (matchingSentences.length > 0) {
      const selectedSentence = selectMediumLengthSentence(matchingSentences);
      sentence = selectedSentence.text;
      sentenceChinese = selectedSentence.chinese;
      subtitleIndex = selectedSentence.index;
      console.log(`为${itemType} "${itemText}" 找到例句:`, sentence, '索引:', subtitleIndex);
    } else {
      console.log(`为${itemType} "${itemText}" 未找到例句`);
    }

    return {
      ...item,
      id: item.id || generateStableId(itemText, itemType),
      sentence: sentence,
      sentenceChinese: sentenceChinese,
      subtitleIndex: subtitleIndex,
      status: item.status || 'unmarked'
    };
  };

  const processedWords = (vocabulary.words || []).map(word => 
    processItem(word, 'word', 'word')
  );

  const processedPhrases = (vocabulary.phrases || []).map(phrase => 
    processItem(phrase, 'phrase', 'phrase')
  );

  const processedExpressions = (vocabulary.expressions || []).map(expression => 
    processItem(expression, 'expression', 'expression')
  );

  // 统一排序：按字母顺序排序，确保两个页面显示完全相同的顺序
  const sortedWords = [...processedWords].sort((a, b) => {
    const textA = (a.word || '').toLowerCase();
    const textB = (b.word || '').toLowerCase();
    return textA.localeCompare(textB);
  });
  
  const sortedPhrases = [...processedPhrases].sort((a, b) => {
    const textA = (a.phrase || '').toLowerCase();
    const textB = (b.phrase || '').toLowerCase();
    return textA.localeCompare(textB);
  });
  
  const sortedExpressions = [...processedExpressions].sort((a, b) => {
    const textA = (a.expression || a.word || a.phrase || '').toLowerCase();
    const textB = (b.expression || b.word || b.phrase || '').toLowerCase();
    return textA.localeCompare(textB);
  });
  
  const result = {
    words: sortedWords,
    phrases: sortedPhrases,
    expressions: sortedExpressions
  };

  console.log('=== 词汇和例句处理完成 ===');
  console.log('处理后的词汇:', result);
  
  if (result.words.length > 0) {
    console.log('第一个单词及例句:', result.words[0]);
  }

  return result;
};
